import { render, staticRenderFns } from "./customer-service.vue?vue&type=template&id=3a0754ee&scoped=true&"
import script from "./customer-service.vue?vue&type=script&lang=js&"
export * from "./customer-service.vue?vue&type=script&lang=js&"
import style0 from "./customer-service.vue?vue&type=style&index=0&id=3a0754ee&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0754ee",
  null
  
)

export default component.exports